export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  cover: string;
  duration: string;
  type: string;
  genres: string[];
  description: string;
  director: string;
  cast: string[];
  region: string;
  language: string;
  episodes: string;
  status: string;
  releaseDate: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  tags: string[];
  playCount: string;
}

export const movies: Movie[] = [
  {
    id: "m1",
    title: "狂飙",
    originalTitle: "The Knockout",
    category: "tv",
    year: 2023,
    rating: 9.1,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20dark%20atmosphere%20and%20two%20men%20in%20tense%20standoff%2C%20cinematic%20lighting%2C%20dark%20background%2C%20film%20grain%20texture&width=400&height=560&seq=movie-poster-m1&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20crime%20drama%20cinematic%20landscape%20with%20city%20skyline%20at%20night%2C%20dark%20moody%20atmosphere%2C%20neon%20lights%2C%20film%20noir%20style%2C%20widescreen%20composition&width=1200&height=500&seq=movie-cover-m1&orientation=landscape",
    duration: "45分钟/集",
    type: "电视剧",
    genres: ["犯罪", "剧情", "悬疑"],
    description: "该剧讲述了以安欣为代表的正义力量，与黑恶势力长达二十年的生死搏斗故事。通过群像叙事展现扫黑行动中的复杂人性与正义较量，是一部制作精良的国产犯罪题材电视剧。剧情环环相扣，演员演技在线，一经播出便引发全民追剧热潮。",
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚", "吴刚"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "39集全",
    status: "已完结",
    releaseDate: "2023-01-14",
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ["国产剧", "高分", "犯罪"],
    playCount: "128.5亿",
  },
  {
    id: "m2",
    title: "流浪地球2",
    originalTitle: "The Wandering Earth II",
    category: "movie",
    year: 2023,
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20movie%20poster%20with%20giant%20spaceship%20and%20earth%20in%20space%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20dark%20space%20background%2C%20cinematic%20poster%20style&width=400&height=560&seq=movie-poster-m2&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20landscape%20with%20massive%20space%20station%20orbiting%20earth%2C%20stars%20in%20background%2C%20cinematic%20widescreen%2C%20dramatic%20lighting%2C%20dark%20and%20grand%20atmosphere&width=1200&height=500&seq=movie-cover-m2&orientation=landscape",
    duration: "173分钟",
    type: "电影",
    genres: ["科幻", "冒险", "灾难"],
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启流浪地球计划。本片为《流浪地球》前传，讲述人类在实施计划过程中面临的惊心动魄的挑战与人类命运共同体的壮丽史诗。视觉效果震撼，剧情扣人心弦。",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢", "宁理"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2023-01-22",
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ["科幻", "大片", "国产"],
    playCount: "86.3亿",
  },
  {
    id: "m3",
    title: "繁花",
    originalTitle: "Blossoms Shanghai",
    category: "tv",
    year: 2024,
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20woman%20in%20cheongsam%2C%20warm%20golden%20lighting%2C%20retro%20aesthetic%2C%20dark%20moody%20background&width=400&height=560&seq=movie-poster-m3&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20signs%20and%20busy%20streets%2C%20warm%20golden%20and%20red%20tones%2C%20nostalgic%20atmosphere%2C%20cinematic%20widescreen&width=1200&height=500&seq=movie-cover-m3&orientation=landscape",
    duration: "45分钟/集",
    type: "电视剧",
    genres: ["剧情", "爱情", "年代"],
    description: "九十年代的上海，改革开放浪潮席卷每个角落。阿宝凭借自己的智慧与勇气，在商海中闯出一片天地。剧集以细腻的笔触刻画了大时代背景下小人物的命运沉浮，画面精美，对白考究，是一部不可多得的年代精品剧。",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    region: "中国大陆",
    language: "汉语普通话 / 沪语",
    episodes: "30集全",
    status: "已完结",
    releaseDate: "2024-01-09",
    isHot: true,
    isNew: true,
    isRecommended: true,
    tags: ["国产剧", "年代", "高分"],
    playCount: "95.7亿",
  },
  {
    id: "m4",
    title: "长相思",
    originalTitle: "Lost You Forever",
    category: "tv",
    year: 2024,
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20woman%20in%20ancient%20costume%2C%20ethereal%20atmosphere%2C%20soft%20lighting%2C%20peach%20blossom%20petals%2C%20elegant%20composition&width=400&height=560&seq=movie-poster-m4&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20landscape%20with%20mountains%20and%20clouds%2C%20ethereal%20misty%20atmosphere%2C%20soft%20warm%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20widescreen&width=1200&height=500&seq=movie-cover-m4&orientation=landscape",
    duration: "45分钟/集",
    type: "电视剧",
    genres: ["古装", "爱情", "奇幻"],
    description: "讲述了上古时期，人神妖混居时代，皓翎国公主玖瑶历经百年颠沛之苦，最终在清水镇落脚，化身玟小六悬壶济世，并与四位男主展开了一段段错综复杂的感情纠葛与命运交织的故事。",
    director: "秦榛",
    cast: ["杨紫", "张晚意", "邓为", "代露娃", "王弘毅"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "39集全",
    status: "已完结",
    releaseDate: "2024-07-22",
    isHot: true,
    isNew: true,
    isRecommended: true,
    tags: ["古装", "爱情", "仙侠"],
    playCount: "112.3亿",
  },
  {
    id: "m5",
    title: "周处除三害",
    originalTitle: "The Pig, the Snake and the Pigeon",
    category: "movie",
    year: 2024,
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Taiwanese%20action%20crime%20film%20poster%20with%20intense%20male%20lead%2C%20dark%20and%20gritty%20atmosphere%2C%20blood%20red%20accents%2C%20film%20noir%20style%2C%20dramatic%20portrait&width=400&height=560&seq=movie-poster-m5&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Dark%20urban%20alley%20at%20night%20with%20neon%20red%20lighting%2C%20gritty%20crime%20atmosphere%2C%20rain%20slicked%20streets%2C%20cinematic%20film%20noir%20style%2C%20widescreen%20composition&width=1200&height=500&seq=movie-cover-m5&orientation=landscape",
    duration: "134分钟",
    type: "电影",
    genres: ["动作", "犯罪", "剧情"],
    description: "通缉犯陈桂林在得知自己身患绝症后，决定在生命尽头除掉排名在自己前面的两大罪犯，以此扬名立万。一场血雨腥风的除害之旅就此展开。影片节奏紧凑，动作场面凌厉，对人性的探讨发人深省。",
    director: "黄精甫",
    cast: ["阮经天", "王净", "袁富华", "陈以文"],
    region: "中国台湾",
    language: "汉语普通话",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2024-03-01",
    isHot: true,
    isNew: true,
    isRecommended: false,
    tags: ["动作", "犯罪", "高分"],
    playCount: "53.8亿",
  },
  {
    id: "m6",
    title: "咒术回战 第二季",
    originalTitle: "Jujutsu Kaisen Season 2",
    category: "anime",
    year: 2023,
    rating: 9.2,
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20powerful%20sorcerer%20character%20in%20dynamic%20pose%2C%20dark%20supernatural%20atmosphere%2C%20vibrant%20blue%20energy%20effects%2C%20anime%20art%20style&width=400&height=560&seq=movie-poster-m6&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20supernatural%20battlefield%20with%20dark%20energy%20and%20glowing%20effects%2C%20destruction%20and%20chaos%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20widescreen&width=1200&height=500&seq=movie-cover-m6&orientation=landscape",
    duration: "24分钟/集",
    type: "动漫",
    genres: ["热血", "战斗", "奇幻"],
    description: "第二季讲述了五条悟与夏油杰在高专时期的过往，以及史上最强的咒术师与咒灵之间的终极对决。制作水准再度提升，战斗场面燃爆，剧情深度与情感刻画令人动容，被誉为年度最佳动画之一。",
    director: "御所园翔太",
    cast: ["榎木淳弥", "内田雄马", "濑户麻沙美", "中村悠一"],
    region: "日本",
    language: "日语",
    episodes: "23集全",
    status: "已完结",
    releaseDate: "2023-07-06",
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ["日漫", "热血", "高分"],
    playCount: "72.1亿",
  },
  {
    id: "m7",
    title: "与凤行",
    originalTitle: "The Legend of Shen Li",
    category: "tv",
    year: 2024,
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20with%20phoenix%20theme%2C%20beautiful%20couple%20in%20ancient%20costumes%2C%20fiery%20golden%20and%20red%20color%20palette%2C%20elegant%20mythological%20aesthetic&width=400&height=560&seq=movie-poster-m7&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Mythological%20Chinese%20landscape%20with%20phoenix%20flying%20over%20ancient%20palace%2C%20golden%20sunset%20sky%2C%20dramatic%20clouds%2C%20fantasy%20atmosphere%2C%20cinematic%20widescreen&width=1200&height=500&seq=movie-cover-m7&orientation=landscape",
    duration: "45分钟/集",
    type: "电视剧",
    genres: ["古装", "奇幻", "爱情"],
    description: "灵界碧苍王沈璃为掌握自己的命运，在逃婚途中意外受伤坠落人间，被下凡体验生活的上古神行止所救。两人在相处中渐生情愫，却不知彼此的真实身份。一段跨越仙凡的虐恋纠葛就此展开。",
    director: "邓科",
    cast: ["赵丽颖", "林更新", "辛云来", "何与"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "39集全",
    status: "已完结",
    releaseDate: "2024-03-18",
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ["古装", "仙侠", "爱情"],
    playCount: "68.4亿",
  },
  {
    id: "m8",
    title: "奥本海默",
    originalTitle: "Oppenheimer",
    category: "movie",
    year: 2023,
    rating: 8.8,
    poster: "https://readdy.ai/api/search-image?query=Biographical%20film%20poster%20with%20mushroom%20cloud%20and%20intense%20male%20portrait%2C%20black%20and%20white%20with%20orange%20fire%2C%20dramatic%20and%20serious%20tone%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-m8&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Nuclear%20explosion%20mushroom%20cloud%20in%20desert%20landscape%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20apocalyptic%20atmosphere%2C%20cinematic%20widescreen%2C%20dramatic%20lighting&width=1200&height=500&seq=movie-cover-m8&orientation=landscape",
    duration: "180分钟",
    type: "电影",
    genres: ["传记", "剧情", "历史"],
    description: "克里斯托弗·诺兰执导的史诗级传记电影，讲述了「原子弹之父」奥本海默的人生故事。从他领导曼哈顿计划制造出世界上第一颗原子弹，到之后面对道德困境与政治迫害的悲剧人生。视听语言震撼，表演精湛绝伦。",
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙", "小罗伯特·唐尼"],
    region: "美国 / 英国",
    language: "英语",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2023-08-30",
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ["好莱坞", "传记", "高分"],
    playCount: "42.6亿",
  },
  {
    id: "m9",
    title: "王牌对王牌 第八季",
    originalTitle: "Ace vs Ace S8",
    category: "variety",
    year: 2024,
    rating: 7.8,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20game%20show%20theme%2C%20hosts%20in%20bright%20costumes%2C%20energetic%20and%20fun%20atmosphere%2C%20stage%20lighting%2C%20entertainment%20vibe&width=400&height=560&seq=movie-poster-m9&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20TV%20studio%20stage%20with%20bright%20lighting%20and%20game%20show%20set%2C%20vibrant%20atmosphere%2C%20entertainment%20venue%2C%20widescreen%20composition&width=1200&height=500&seq=movie-cover-m9&orientation=landscape",
    duration: "90分钟/期",
    type: "综艺",
    genres: ["游戏", "搞笑", "真人秀"],
    description: "国内王牌综艺节目第八季重磅回归！每期邀请当红明星嘉宾进行趣味游戏PK对决，爆笑不断，惊喜连连。经典游戏环节全新升级，更有神秘嘉宾空降制造超多名场面，是周末放松的绝佳选择。",
    director: "吴彤",
    cast: ["沈腾", "贾玲", "华晨宇", "关晓彤", "宋亚轩"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "更新至第12期",
    status: "更新中",
    releaseDate: "2024-06-28",
    isHot: true,
    isNew: true,
    isRecommended: false,
    tags: ["综艺", "搞笑", "热门"],
    playCount: "82.7亿",
  },
  {
    id: "m10",
    title: "蓝色星球2",
    originalTitle: "Blue Planet II",
    category: "documentary",
    year: 2017,
    rating: 9.8,
    poster: "https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%20with%20deep%20ocean%20and%20diverse%20marine%20life%2C%20blue%20whale%20and%20coral%20reef%2C%20majestic%20underwater%20scene%2C%20documentary%20film%20poster&width=400&height=560&seq=movie-poster-m10&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Breathtaking%20underwater%20ocean%20landscape%20with%20sunlight%20rays%20piercing%20through%20deep%20blue%20water%2C%20diverse%20marine%20life%2C%20coral%20reef%2C%20cinematic%20widescreen%2C%20documentary%20style&width=1200&height=500&seq=movie-cover-m10&orientation=landscape",
    duration: "60分钟/集",
    type: "纪录片",
    genres: ["自然", "海洋", "探索"],
    description: "BBC历时四年拍摄的史诗级海洋纪录片，足迹遍布全球39个国家，探索了从极地冰海到热带珊瑚礁的神秘水下世界。4K超高清画质，每一帧都是壁纸级别，带领观众领略前所未见的海洋奇观与生命奇迹。",
    director: "詹姆斯·霍尼伯内",
    cast: ["大卫·爱登堡"],
    region: "英国",
    language: "英语",
    episodes: "7集全",
    status: "已完结",
    releaseDate: "2017-10-29",
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ["BBC", "纪录片", "神作"],
    playCount: "35.2亿",
  },
  {
    id: "m11",
    title: "热辣滚烫",
    originalTitle: "YOLO",
    category: "movie",
    year: 2024,
    rating: 7.5,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%20with%20confident%20woman%20boxing%20theme%2C%20warm%20and%20inspiring%20tone%2C%20golden%20lighting%2C%20motivational%20atmosphere&width=400&height=560&seq=movie-poster-m11&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Boxing%20gym%20interior%20with%20warm%20golden%20lighting%2C%20inspiring%20atmosphere%2C%20motivational%20training%20scene%2C%20cinematic%20widescreen%2C%20sports%20drama%20style&width=1200&height=500&seq=movie-cover-m11&orientation=landscape",
    duration: "129分钟",
    type: "电影",
    genres: ["喜剧", "剧情", "励志"],
    description: "乐莹是一个善良的女孩，却总是被生活欺负。在一次次的打击之后，她选择了拳击作为自己人生的出口。从体重的改变到内心的蜕变，乐莹用拳头打出了属于自己的滚烫人生。笑中带泪的励志故事，献给每一个在生活中奋力前行的人。",
    director: "贾玲",
    cast: ["贾玲", "雷佳音", "张小斐", "杨紫"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2024-02-10",
    isHot: false,
    isNew: false,
    isRecommended: false,
    tags: ["喜剧", "励志", "春节档"],
    playCount: "96.1亿",
  },
  {
    id: "m12",
    title: "进击的巨人 最终季",
    originalTitle: "Attack on Titan Final Season",
    category: "anime",
    year: 2023,
    rating: 9.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20anime%20poster%20with%20giant%20titan%20and%20soldiers%20in%20epic%20battle%2C%20dramatic%20lighting%2C%20apocalyptic%20atmosphere%2C%20anime%20art%20style%2C%20intense%20action&width=400&height=560&seq=movie-poster-m12&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Apocalyptic%20anime%20landscape%20with%20destroyed%20city%20and%20giant%20figures%2C%20dark%20dramatic%20sky%2C%20epic%20scale%2C%20anime%20art%20style%2C%20widescreen&width=1200&height=500&seq=movie-cover-m12&orientation=landscape",
    duration: "24分钟/集",
    type: "动漫",
    genres: ["热血", "战斗", "奇幻"],
    description: "人类与巨人之间的终极对决迎来最终篇章。艾伦发动地鸣，世界陷入前所未有的危机。曾经并肩作战的伙伴们不得不做出最艰难的选择。神作完结篇，震撼人心的史诗级结局，为这部世纪之作画上句号。",
    director: "林祐一郎",
    cast: ["梶裕贵", "石川由依", "井上麻里奈", "下野纮"],
    region: "日本",
    language: "日语",
    episodes: "完结篇全",
    status: "已完结",
    releaseDate: "2023-11-04",
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ["日漫", "神作", "热血"],
    playCount: "98.5亿",
  },
  {
    id: "m13",
    title: "孤注一掷",
    originalTitle: "No More Bets",
    category: "movie",
    year: 2023,
    rating: 7.3,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20and%20tense%20atmosphere%2C%20poker%20chips%20and%20money%2C%20gambling%20theme%2C%20dramatic%20lighting%2C%20suspenseful%20tone&width=400&height=560&seq=movie-poster-m13&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Dark%20casino%20interior%20with%20neon%20lights%20and%20poker%20tables%2C%20tense%20gambling%20atmosphere%2C%20crime%20theme%2C%20dramatic%20lighting%2C%20cinematic%20widescreen&width=1200&height=500&seq=movie-cover-m13&orientation=landscape",
    duration: "130分钟",
    type: "电影",
    genres: ["犯罪", "剧情", "悬疑"],
    description: "程序员潘生和模特安娜被海外高薪招聘所吸引，却意外陷入境外诈骗工厂的魔窟。在残酷的现实面前，他们必须想尽一切办法逃离这个人间地狱。改编自真实诈骗案例，揭露境外网络诈骗全产业链内幕，极具现实意义。",
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅", "王传君"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2023-08-08",
    isHot: false,
    isNew: false,
    isRecommended: false,
    tags: ["犯罪", "悬疑", "现实题材"],
    playCount: "78.9亿",
  },
  {
    id: "m14",
    title: "地球脉动 第三季",
    originalTitle: "Planet Earth III",
    category: "documentary",
    year: 2024,
    rating: 9.9,
    poster: "https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%20with%20diverse%20wildlife%20from%20around%20the%20world%2C%20elephant%20and%20eagle%2C%20stunning%20natural%20beauty%2C%20documentary%20film%20poster%20style&width=400&height=560&seq=movie-poster-m14&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Stunning%20mountain%20and%20forest%20landscape%20with%20diverse%20wildlife%2C%20golden%20sunset%20light%2C%20epic%20natural%20beauty%2C%20cinematic%20widescreen%2C%20documentary%20style&width=1200&height=500&seq=movie-cover-m14&orientation=landscape",
    duration: "60分钟/集",
    type: "纪录片",
    genres: ["自然", "野生动物", "探索"],
    description: "BBC自然纪录片皇冠上的明珠，时隔七年再度回归。以突破性的拍摄技术和前所未有的视角，记录了地球上最壮丽的自然奇观和最动人的动物故事。从深海的奇异生物到极地的冰雪世界，每一集都是视觉与心灵的双重盛宴。",
    director: "尼克·伊斯顿",
    cast: ["大卫·爱登堡"],
    region: "英国",
    language: "英语",
    episodes: "8集全",
    status: "已完结",
    releaseDate: "2024-04-05",
    isHot: false,
    isNew: true,
    isRecommended: true,
    tags: ["BBC", "纪录片", "神作"],
    playCount: "28.6亿",
  },
  {
    id: "m15",
    title: "奔跑吧 第十季",
    originalTitle: "Keep Running S10",
    category: "variety",
    year: 2024,
    rating: 7.6,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20reality%20variety%20show%20poster%20with%20energetic%20cast%20running%2C%20bright%20and%20colorful%20design%2C%20outdoor%20adventure%20theme%2C%20fun%20and%20dynamic%20atmosphere&width=400&height=560&seq=movie-poster-m15&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Bright%20colorful%20outdoor%20park%20with%20obstacle%20course%20and%20game%20elements%2C%20sunny%20day%2C%20energetic%20atmosphere%2C%20variety%20show%20setting%2C%20widescreen&width=1200&height=500&seq=movie-cover-m15&orientation=landscape",
    duration: "100分钟/期",
    type: "综艺",
    genres: ["户外", "游戏", "真人秀"],
    description: "国民综艺奔跑吧第十季全新起航！常驻MC阵容再度升级，每期邀请飞行嘉宾前往全国各地进行趣味游戏挑战。搞笑互动不断，户外冒险精彩纷呈，用欢笑和热血陪伴观众的每一个周末。",
    director: "姚译添",
    cast: ["李晨", "郑恺", "杨颖", "沙溢", "白鹿", "周深"],
    region: "中国大陆",
    language: "汉语普通话",
    episodes: "更新至第8期",
    status: "更新中",
    releaseDate: "2024-05-17",
    isHot: true,
    isNew: true,
    isRecommended: false,
    tags: ["综艺", "户外", "热门"],
    playCount: "61.2亿",
  },
  {
    id: "m16",
    title: "汪汪队立大功 大电影2",
    originalTitle: "PAW Patrol: The Mighty Movie",
    category: "kids",
    year: 2024,
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Animated%20kids%20movie%20poster%20with%20cute%20puppy%20superheroes%2C%20bright%20colorful%20and%20fun%20design%2C%20adventure%20theme%2C%20children%20animation%20style%2C%20playful%20atmosphere&width=400&height=560&seq=movie-poster-m16&orientation=portrait",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20animated%20adventure%20city%20with%20cute%20puppy%20characters%20flying%2C%20bright%20sky%2C%20fun%20and%20energetic%20atmosphere%2C%20kids%20animation%20style%2C%20widescreen&width=1200&height=500&seq=movie-cover-m16&orientation=landscape",
    duration: "92分钟",
    type: "动漫",
    genres: ["冒险", "动画", "儿童"],
    description: "汪汪队再次集结出击！这次狗狗们获得了神秘超能力，化身为超级英雄守护冒险城。全新的装备、更强大的敌人、更刺激的冒险，小朋友们最爱的汪汪队带来了一场欢乐又勇敢的动画盛宴。",
    director: "卡尔·布伦克尔",
    cast: ["麦肯娜·格蕾丝", "塔拉吉·P·汉森"],
    region: "美国",
    language: "英语 / 汉语普通话",
    episodes: "全1集",
    status: "已上映",
    releaseDate: "2024-06-01",
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ["动画", "儿童", "冒险"],
    playCount: "45.8亿",
  },
];